import { render, staticRenderFns } from "./FolderGallery.vue?vue&type=template&id=4f5c5564&scoped=true&"
import script from "./FolderGallery.vue?vue&type=script&lang=js&"
export * from "./FolderGallery.vue?vue&type=script&lang=js&"
import style0 from "./FolderGallery.vue?vue&type=style&index=0&id=4f5c5564&lang=scss&scoped=true&"
import style1 from "./FolderGallery.vue?vue&type=style&index=1&id=4f5c5564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5c5564",
  null
  
)

export default component.exports